import { render, staticRenderFns } from "./DocsIndex.vue?vue&type=template&id=39e1a34c&"
import script from "./DocsIndex.vue?vue&type=script&lang=js&"
export * from "./DocsIndex.vue?vue&type=script&lang=js&"
import style0 from "./DocsIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports